import { render, staticRenderFns } from "./websitePointsOrder.vue?vue&type=template&id=cffb3890&scoped=true&"
import script from "./websitePointsOrder.vue?vue&type=script&lang=js&"
export * from "./websitePointsOrder.vue?vue&type=script&lang=js&"
import style0 from "./websitePointsOrder.vue?vue&type=style&index=0&id=cffb3890&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cffb3890",
  null
  
)

export default component.exports